<template>
  <div class="users card">
    <page-header title="Users" breadcrumbText="Dashboard >> Users" />
    <users-table />
  </div>
</template>

<script>
import UsersTable from "./UsersTable";
export default {
  components: {
    UsersTable,
  },
};
</script>

<style></style>
